import * as ReactDOM from "react-dom";
import * as React from "react";
import * as $ from "jquery";
import { Secured } from "../../applications/Dashboard/Components/Secured";
import { SecuredMainNavigation } from "../../applications/Dashboard/Components/SecuredMainNavigation";
import { SecuredHeader } from "../../applications/Dashboard/Components/SecuredHeader";
import { SiteLayout } from "../../applications/DLU/SiteLayout";
import { ClientDashboardHeader } from "../../applications/DLU/ClientDashboardHeader";
import { SecuredFooter } from "../../applications/Dashboard/Components/SecuredFooter";
import { LogoHeader } from "../../applications/DLU/LogoHeader";

$(document).ready(() => {
    if (document.getElementById("AppTarget")) {
        ReactDOM.render(<Secured />, $("#AppTarget")[0]);
    }
    if (document.getElementById("SecuredNavigationTarget")) {
        ReactDOM.render(
            <SiteLayout>
                <SecuredMainNavigation />
            </SiteLayout>,
            document.getElementById("SecuredNavigationTarget")
        );
    }
    if (document.getElementById("SecuredHeaderTarget")) {
        ReactDOM.render(
            <SiteLayout>
                <SecuredHeader />
            </SiteLayout>,
            document.getElementById("SecuredHeaderTarget")
        );
    }
    if (document.getElementById("ClientDashboardHeaderTarget")) {
        ReactDOM.render(
            <SiteLayout>
                <ClientDashboardHeader />
            </SiteLayout>,
            document.getElementById("ClientDashboardHeaderTarget")
        );
    }
    if (document.getElementById("LogoHeaderTarget")) {
        ReactDOM.render(<LogoHeader />, document.getElementById("LogoHeaderTarget"));
    }
    if (document.getElementById("SecuredFooterTarget")) {
        ReactDOM.render(<SecuredFooter />, document.getElementById("SecuredFooterTarget"));
    }
});
